import React, { useEffect } from "react";
import FormControl from "@material-ui/core/FormControl";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import { useDispatch, useSelector } from "react-redux";
import { setTenantAction } from "../reducers";
import Tooltip from "@material-ui/core/Tooltip";
import { useIntl } from "react-intl";
import { ROUTES_USERS, SESSION_USER_TENANTS_KEY } from "../utils/constants";
import { resetRedux } from "../utils/utils";
import { useNavigate, useParams } from "react-router";

const useStyles = makeStyles((theme) => ({
  customWidth: {
    minWidth: 320,
    textAlign: "center",
  },
  formControl: {
    width: "150px !important",
    "& .MuiInputBase-root": {
      color: "white !important",
      paddingRight: theme.spacing(1),
      width: "150px !important",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "2px solid white",
      color: "white !important",
    },
    "& .MuiSelect-icon": {
      color: "white !important",
    },
  },
  label: {
    color: theme.palette.primary.main,
  },
}));

const TenantSelector = () => {
  const intl = useIntl();
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const storedTenant = localStorage.getItem("masbranSelectedTenant");

  const tenants = !!sessionStorage.getItem(SESSION_USER_TENANTS_KEY)
    ? JSON.parse(sessionStorage.getItem(SESSION_USER_TENANTS_KEY))
    : [];
  const tenant = useSelector((state) => state.tenant);

  const handleChange = (value) => {
    localStorage.setItem("masbranSelectedTenant", value);
    dispatch(setTenantAction(value));
    resetRedux();
    if (!!id) {
      navigate(ROUTES_USERS);
    }
  };

  useEffect(() => {
    if (storedTenant) {
      handleChange(storedTenant);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FormControl className={classes.formControl}>
      <Tooltip
        placement={"left"}
        title={intl.formatMessage({ id: "custom.tenant.selector" })}
        classes={{ tooltip: classes.customWidth }}
      >
        <Select
          IconComponent={ExpandMoreRoundedIcon}
          autoWidth
          labelId="tenant-selector-label"
          value={tenant}
          onChange={(e) => handleChange(e.target.value)}
        >
          {tenants?.map((t) => (
            <MenuItem key={t} value={t}>
              {t}
            </MenuItem>
          ))}
        </Select>
      </Tooltip>
    </FormControl>
  );
};

export default TenantSelector;
